import { useCallback, useState } from 'react'

export function useUpsellModal(): {
  isModalVisible: boolean
  showModal: () => void
  hideModal: () => void
} {
  const [isModalVisible, setIsModalVisible] = useState(false)

  const showModal = useCallback(() => setIsModalVisible(true), [])
  const hideModal = useCallback(() => setIsModalVisible(false), [])

  return {
    hideModal,
    isModalVisible,
    showModal,
  }
}
